import { useTranslation } from 'react-i18next';
import { Icon, Tooltip } from '@anytag/shared-atoms';

export interface RegenerateButtonProps {
  onRegenerate: () => void;
}
export const RegenerateButton = ({ onRegenerate }: RegenerateButtonProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip help={t<string>('Tooltip.RegenerateMessage')}>
      <div className="flex" onClick={onRegenerate}>
        <Icon size={11} icon="refresh" variant="gray" className="cursor-pointer hover:opacity-85" />
      </div>
    </Tooltip>
  );
};
